<script>
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";
import Modal from "../../components/shared/Modal/Modal.vue";
import CustomInputWithImg from "../../components/shared/UI/CustomInputWithImg.vue";
import { DataService } from "../../config/dataService";
import store from "../../vuex/store";
import DataPage from "../DataPage/DataPage.vue";
import CreateBotForm from "../CreateBots/CreateBotForm.vue";

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  components: {
    DataPage,
    Modal,
    CustomInputWithImg,
    ButtonWithLoadWebsite,
    CreateBotForm,
  },
  data() {
    return {
      isAddLinkModalOpen: false,
      websiteLink: ""
    };
  },
  computed: {
    isLoading() {
      return store?.getters.isLoading;
    },

    chosenWidget() {
      return store.state.users.chosenWidget;
    },

    createBotData() {
      return store?.state?.createBotData?.data;
    },

    isSingleLink() {
      const { linkType } = this.createBotData;
      return linkType === 'Single link';
    },

    btnDisabled() {
      const { websiteLink, links } = this.createBotData;
      return this.isSingleLink ? !this.isValidURL(websiteLink) : websiteLink === "" ? true : links.length === 0 ? true : false;
    }
  },

  methods: {
    async updateChosenWidget() {
      try {
        const result = await DataService.get(
          `${API_ENDPOINT}widget/get-by-id/${this.chosenWidget?.id}`
        );

        store.dispatch("setChosen", result?.data);
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.errorDescription ||
          "Update chosen widget error"
        );
      }
    },

    handleAddClick() {
      this.clearLocalBotData();
      this.isAddLinkModalOpen = true;
    },

    async handleLinksAdd() {
      try {
        const {
          websiteLink: link,
          links: sources,
          linkType: type,
        } = this.createBotData;

        store.dispatch("startLoading");

        await DataService.post(
          `${API_ENDPOINT}widget/addLinksSource/${this.chosenWidget?.id}`,
          { data: { sources: this.isSingleLink ? [link] : sources }, sourceType: type },
          { widgetId: this.chosenWidget?.id }
        );

        this.clearLocalBotData();
        await this.updateChosenWidget(this.chosenWidget?.id);

        this.isAddLinkModalOpen = false;
        this.$toast.success(
          (this.isSingleLink ? '1 link' : `${sources.length} links`) + ' added.'
        );
      } catch (error) {
        const errorMessage = error?.response?.data?.errorDescription === 'Access is denied. Contact support'
          ? 'To add more links you need to upgrade your tariff plan'
          : error?.response?.data?.errorDescription || "Link add error";
        this.$toast.error(
          errorMessage
        );
      } finally {
        store.dispatch("endLoading");
      }
    },
    clearLocalBotData() {
      const botDataKeys = ["botData", "botDataSelectedLinks", "botSettings"];
      botDataKeys.forEach((value) => localStorage.removeItem(value));
    },
    closeModalHandler() {
      this.isAddLinkModalOpen = false;
      this.clearLocalBotData();
    },
    isValidURL(url) {
      const urlPattern =
        /^((http|https):\/\/)?(www\.)?([A-Za-z0-9]{1}[A-Za-z0-9\-]*\.?)*\.{1}[A-Za-z0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/;

      return urlPattern.test(url);
    },
  },
};
</script>

<template>
  <div>
    <DataPage @addClick="handleAddClick" dataType="link" title="Links" />

    <Modal :isModalOpen="isAddLinkModalOpen" @close="closeModalHandler">
      <div slot="body" class="modal_body">
        <div class="add_link_wrapper">
          <div class="add_link_form">
            <CreateBotForm :isCreateBot="false" />
          </div>

          <div class="form_btn_wrapper">
            <ButtonWithLoadWebsite class="create_btn_text" type="submit" title="Add" :isDisabled="btnDisabled"
              @onClick="handleLinksAdd()" />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<style scoped>
:deep(.modal__box) {
  padding: 30px;
  max-width: 95vw;
  max-height: 95vh;
  display: block;
  min-width: 895px;
  overflow-y: auto;
}

@media screen and (max-width: 920px) {
  :deep(.modal__box) {
    min-width: auto;
  }
}

.modal_body {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 50px;
}

@media screen and (max-width: 768px) {
  :deep(.modal__box) {
    padding: 0 20px;
  }
}

.add_link_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 595px;
}

.add_link_form {
  padding: 20px 0;
}

.form_btn_wrapper {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.create_btn_text {
  color: #f8fafc;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  padding: 10px 20px;
  width: 174px;
}
</style>
